




































































import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import moment from 'moment'
import { WorkbookService as _workbookService } from '@/services/workbook.service'
import WorkbookEntryModal from '@/modals/WorkbookEntry.modal.vue'
import { WorkbookEntryDto } from '@/models/dtos/workbookEntryDto'

@Component({
  components: {
    WorkbookEntryModal
  }
})
export default class Workbook extends Vue {
  // Data
  private workbookEntries: WorkbookEntryDto[] = []
  private currentPage: number = 1
  private perPage: number = 15
  private items: { id: string; date: string; project: string; message: string; time: string }[] = []
  private fields = [
    { key: 'date', label: 'Data', class: 'align-middle' },
    { key: 'project', label: 'Nazwa projektu', class: 'align-middle' },
    { key: 'message', label: 'Wiadomość', class: 'align-middle' },
    { key: 'time', label: 'Godziny pracy', class: 'align-middle' },
    { key: 'actions', label: 'Akcje', class: 'align-middle' }
  ]

  // Methods
  private async initWorkbookEntries() {
    this.items = []
    const startDate = moment().subtract(30, 'days').startOf('day').toDate()
    this.workbookEntries = await _workbookService.getWorkbookFromRange(startDate)

    for (const entry of this.workbookEntries) {
      this.items.push({
        id: entry.id!,
        date: moment(entry.date).format('llll'),
        project: entry.project.name,
        message: entry.message,
        time: `${entry.startTime} - ${entry.endTime}`
      })
    }
  }

  private async removeEntry(id: string) {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć ten wpis', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderCancel: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _workbookService.removeWorkbookEntry(id)
      this.initWorkbookEntries()
    }
  }

  private async editEntry(id: string) {
    const entry = this.workbookEntries.find(e => e.id === id)
    if (entry) {
      this.$root.$emit('show-workbook-entry-modal', entry)
    }
  }

  // Lifecycle
  async created() {
    this.initWorkbookEntries()

    this.$root.$on('worbook-entry-modal-saved', this.initWorkbookEntries)
  }
}
